import React, { Component } from "react";
import { connect } from "react-redux";

import NavButton from "./NavButton";
import ActiveLine from "./ActiveLine";
import MenuButton from "./MenuButton";
import CategoryButton from "./CategoryButton";
import MainMenu from "./MainMenu";
import CategoriesMenu from "./CategoriesMenu";

import {
  getProductCategories,
  setCurrentCategory,
  validateUser,
  outSideClick,
  getCatalogOptions
} from "../actions/siteActions";
import { MobileView, isMobile } from "react-device-detect";

class Topbar extends Component {
  componentDidMount = () => {
    // console.log("YES");
    this.props.getCatalogOptions();
    this.props.getProductCategories();
  };

  componentDidUpdate = (prevProps) => {
    //  console.log(this.props.site.categories, prevProps.site.categories);
    if (this.props.site.categories !== prevProps.site.categories) {
      this.props.setCurrentCategory(this.props.site.categories[0]);
    }
  };

  createCategoryButtons = () => {
    const { site } = this.props;

    return Object.keys(site.categories).map((key, i) => {
      return <NavButton key={i} attributes={site.categories[key]} />;
    });
  };

  onCatalogClick = () => {
    this.props.outSideClick(this.props.site.menu.open);
  };

  render() {
    const { site } = this.props;
    return (
      <div
        className={`top-bar ${
          (site.menu.open || site.categorymenu.open) && "is-active"
        }`}
        onClick={() => this.onCatalogClick()}
      >
        <div className="navButtons">
          {isMobile && <CategoryButton />}
          <MenuButton />
          {site.categories && this.createCategoryButtons()}
        </div>
        <ActiveLine />
        {site.categorymenu.open && isMobile && <CategoriesMenu />}
        {site.menu.open && <MainMenu />}
        <MobileView>
          <img
            className="logo"
            src={process.env.PUBLIC_URL + "/img/ep_logo.svg"}
            alt="logo"
          />
        </MobileView>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  site: state.site,
});

export default connect(mapStateToProps, {
  getProductCategories,
  setCurrentCategory,
  validateUser,
  outSideClick,
  getCatalogOptions
})(Topbar);
